import { useCallback, useLayoutEffect, useRef, useState } from 'react'

const DEFAULT_HEIGHT = 'auto'

export const useAutoresizeTextArea = (inputValue: string, enabled: boolean) => {
  const ref = useRef<HTMLTextAreaElement>(null)
  const [height, setHeight] = useState(DEFAULT_HEIGHT)

  useLayoutEffect(() => {
    if (!enabled || !ref.current) return
    // Valeur vidée par le code (ex. après envoi) : onInput ne se déclenche pas, on revient à la hauteur initiale.
    setHeight(inputValue === '' ? DEFAULT_HEIGHT : `${ref.current.scrollHeight}px`)
  }, [enabled, inputValue])

  const resetHeight = useCallback(() => {
    setHeight(DEFAULT_HEIGHT)
  }, [])

  return { height, ref, resetHeight }
}
